import { useState } from "react";
import { ArticleDataObject } from "@app/types/Cue";
import axios from "axios";

export const useLoadMoreStoriesByCategory = (
  category: string,
  parentCategory: string,
  initialList: ArticleDataObject[],
  pageSize: number
) => {
  const [articleList, setArticleList] =
    useState<ArticleDataObject[]>(initialList);
  const [hasMoreArticles, setHasMoreArticles] = useState(
    initialList.length === pageSize
  );

  const handleLoadMore = async () => {
    const lastArticle = initialList.at(-1);

    if (initialList.length === 0) return;
    if (typeof lastArticle === "undefined") return;

    const newMoreArticles = await fetchStories(
      category,
      parentCategory,
      lastArticle
    );

    if (newMoreArticles.length < pageSize) setHasMoreArticles(false);

    setArticleList((prev) => [...prev, ...newMoreArticles]);
  };

  return { articleList, handleLoadMore, hasMoreArticles };
};

const fetchStories = async (
  category: string,
  parentCategory: string,
  article: ArticleDataObject
) => {
  try {
    const response = await axios.post("/_plat/api/v1/more-stories", {
      category,
      parentCategory,
      sort: article.sort,
    });

    return response?.data || [];
  } catch (error) {
    console.log("error on fetchStories"); // eslint-disable-line no-console
    return [];
  }
};
